export default class ErrorCode {
    static  CODE_SUCCESS            = 0
    static  CODE_FAILED             = 1 //系统错误
    static  CODE_MULTI_REGISTER     = 2
    static  CODE_DB_ERROR           = 3
    static  CODE_ACORPWD_ERROR      = 4  //账号或密码错误
    static  CODE_FASTLOGIN_ERROR    = 5  //快捷登陆已失效
    static  CODE_NAME_TOO_LONG      = 6  //昵称太长
    static  CODE_PWD_LEN_ERROR      = 7  //密码长度错误
    static  CODE_PLAYTMS_NOT_ENOUGH = 8  //没有播放次数了
    static  CODE_OLDPWD_ERROR       = 9  //旧密码错误
    static  CODE_SCORE_NOT_ENOUGH   = 10 //金币不够
    static  CODE_VERIFY_CODE_ERROR  = 11 //验证码错误
}